import apiService from 'apiService'
import React from 'react'
import { toast } from 'react-toastify'

export default function EnableUserIcon({ userId, refreshTable }) {
    const handleClick = async () => {
        const payload = {
            enabled: 1
        }
        await apiService.put(`/users/${userId}`, payload)
        refreshTable(+Date.now())
        toast.success('Επιτυχής ενεργοποίηση χρήστη!', {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            theme: 'colored'
        })
    }

    return <i title="Ενεργοποίηση Χρήστη" className="fas fa-user-plus text-emerald-500 mr-2" onClick={handleClick} style={{ cursor: 'pointer' }}></i>
}
